import React, { useState, useContext, useEffect } from "react";
import PickListContext from "src/context/pickListContext";
import { Page, DataTable, PageHero } from "src/components/common";
import { Link } from "react-router-dom";
import { Button } from "src/components/buttons";
import {
	ActionIcon,
	ClearFilterButton,
} from "src/components/forms/ActionColumnIconsAndButton";
import {
	setStatusCellValue,
	filterByStatus,
	StatusFilterMethod,
} from "src/components/forms/StatusFilter";
import pickListAPI from "./pickListAPI";
import { Tooltip } from "antd";

interface IProps {
	history: any;
	match: any;
}

const PickListItemListPage: React.FC<IProps> = (props: IProps) => {
	const { pickListTypeId } = props.match.params;
	const { pickListTypes } = useContext(PickListContext);
	const [data, setData] = useState<PickListItem[]>([]);
	const [filtered, setFiltered] = useState<any[]>([]);
	const [isLoading, setIsLoading] = useState<boolean>(false);
	const [pickListType, setPickListType] = useState<PickListType>({
		id: undefined,
		code: "",
		description: "",
		parentId: undefined,
		isActive: undefined,
	});

	useEffect(() => {
		const foundPickListType = pickListTypes.find(
			(pType: PickListType) => pType.id === Number(pickListTypeId)
		);
		if (foundPickListType !== undefined) {
			setPickListType(foundPickListType);
			fetchPickList(foundPickListType.code!);
		}

		async function fetchPickList(code: string) {
			setIsLoading(true);
			const res = await pickListAPI.getPickListItemByType(code);
			setData(res);
			setIsLoading(false);
		}
	}, []);

	const clearFilters = () => {
		setFiltered([]);
	};

	const columns = [
		{
			Header: <Tooltip title="Code">Tooltip</Tooltip>,
			accessor: "code",
		},
		{
			Header: <Tooltip title="Description">Description</Tooltip>,
			accessor: "description",
		},
		{
			Header: <Tooltip title="Active">Active</Tooltip>,
			accessor: "isActive",
			Cell: setStatusCellValue,
			filterMethod: filterByStatus("isActive"),
			Filter: StatusFilterMethod,
		},
		{
			Header: <Tooltip title="Actions">Actions</Tooltip>,
			id: "Actions",
			Cell: <ActionIcon title="Edit" type="edit" />,
			Filter: <ClearFilterButton onClick={clearFilters} />,
		},
	];

	const getActionLink = (rowId: any): string => {
		return `./pick-list-items/${rowId}`;
	};

	const onRowClick = ({ row }: any) => {
		props.history.push(getActionLink(row._original.id));
	};

	return (
		<Page
			title={`${
				pickListType.description !== undefined ? pickListType.description : ""
			}`}
		>
			<div className="container">
				<PageHero>
					<Link to="/admin/pick-lists">&lt; GO BACK</Link>
					<div className="d-flex">
						<h1 className="mb-0">
							{pickListType.description !== undefined
								? pickListType.description
								: ""}
						</h1>
						<Button
							className="btn-primary ml-auto"
							to={`/admin/pick-lists/${props.match.params.pickListTypeId}/pick-list-items/0`}
						>
							<span style={{ textTransform: "capitalize" }}>
								Add PickList Item
							</span>
						</Button>
					</div>
				</PageHero>
				<DataTable
					data={data}
					columns={columns}
					onRowClick={onRowClick}
					filterable={true}
					filtered={filtered}
					onFilteredChange={(f: any[]) => setFiltered(f)}
					loading={isLoading}
				/>
			</div>
		</Page>
	);
};

export default PickListItemListPage;
